export default "__VITE_ASSET__C4Opw_wG__"